import React, { useState, useRef } from 'react';
import PartnerCarousel from './partnerCarousel';
import Footer from './footer';
import FAQ from './faq';
import Header from './header';
import { useNavigate } from 'react-router-dom';

const Contact = () => {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        whatsapp: "",
        message: "",
    });

    const [error, setError] = useState(false);

    const handleChange = (e: any) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setError(false);
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const { fullName, email, whatsapp, message } = formData;
        if (!fullName || !email || !whatsapp || !message) {
            setError(true);
        } else {
            // Lógica de envio (ex: API)
            console.log("Formulário enviado:", formData);
            alert("Formulário enviado com sucesso!");
            setFormData({
                fullName: "",
                email: "",
                whatsapp: "",
                message: "",
            });
        }
    };

    return (
        <div className=" bg-white flex flex-col w-[100%] h-[100%] dark:bg-maincodeSecondBlueDark dark:text-white">
            <div className="w-[100%] h-screen flex flex-col bg-gradient-to-br from-[#420C8D] to-[#615cb7] lg:bg-cover lg:bg-center lg:bg-no-repeat" style={{ backgroundImage: "url('Component 232 (2).png')" }}>
                <div id='inicio' className='pt-5 pl-3 h-[10%] lg:h-[20%] lg:flex lg:items-center'>
                    <Header />
                </div>
                <div className='flex items-center justify-start h-[90%] lg:h-[80%] w-screen'>
                    <div className='lg:relative lg:pl-20 lg:w-[65%] w-screen lg:justify-center mt-10 items-center h-[100%] flex flex-col text-white'>
                        <div className='flex flex-col pl-8 lg:items-start lg:justify-center'>
                            <h1 className='text-2xl mb-5 lg:text-5xl lg:mb-8'>Entre em contato conosco</h1>
                            <p className='text-md w-[85%] lg:text-2xl lg:w-[85%] lg:text-start'>Gostaria de fechar uma parceria ou tem alguma dúvida? Entre em contato conosco pelos canais abaixo, e um de nossos especialistas irá atendê-lo!</p>
                        </div>
                        <div className=' flex flex-col w-[100%] h-[30%] lg:flex-row lg:items-start lg:mb-10 lg:mt-10'>
                            <div className=' flex flex-col pl-8 justify-center lg:items-start lg:mr-32 lg:mt-0'>
                                <p className='font-semibold mt-5 mb-3 lg:text-2xl'>WhatsApp </p>
                                <p className='text-white dark:text-white font-bold flex'><span className='font-normal text-white dark:text-white mr-1'></span> (12) 99714-3862 <a
                                    href="https://wa.me/5512997143862"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className=""
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" className="w-4 h-4  -rotate-45">
                                        <path d="M10.828 5.172a.5.5 0 0 1 .707-.707l3 3a.5.5 0 0 1 0 .707l-3 3a.5.5 0 1 1-.707-.707L12.793 8.5H5.5a.5.5 0 0 1 0-1h7.293l-1.965-1.965Z" />
                                    </svg>
                                </a></p>
                            </div>
                            <div className=' flex dark:text-white flex-col justify-center pl-8 mb-10 lg:items-start lg:m-0'>
                                <p className='font-semibold mt-5 mb-3 lg:text-2xl'>E-mail</p>
                                <p className='text-white dark:text-white  font-bold flex'><span className='font-normal text-white dark:text-white mr-1'></span> contato@declareidigital.com.br <a
                                    href="mailto:contato@declareidigital.com.br"
                                    className="ml-1"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" className="w-4 h-4  -rotate-45">
                                        <path d="M10.828 5.172a.5.5 0 0 1 .707-.707l3 3a.5.5 0 0 1 0 .707l-3 3a.5.5 0 1 1-.707-.707L12.793 8.5H5.5a.5.5 0 0 1 0-1h7.293l-1.965-1.965Z" />
                                    </svg>
                                </a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='bg-[#001F40] z-20 lg:flex-row bg-maincodeLightBlue  lg:justify-evenly flex flex-col pt-10 pb-10 pl-5 pr-5'>
                <div className='flex flex-col lg:w-[40%] lg:mt-16 lg:mb-10'>
                    <h1 className='text-white lg:text-5xl text-3xl'>Você pode nos enviar a sua dúvida através das nossas redes</h1>
                    <p className='text-white lg:text-3xl lg:mt-10 lg:mb-10 lg:w-[90%] text-xl mb-5'>E em breve um dos nossos especialistas entrará em contato para responder as suas dúvidas!</p>
                    <div className='lg:flex lg:justify-between w-[100%] h-[15%] justify-evenly mb-8 md:w-[30%] hidden'>
                        <div>
                            <a target='_blank' href="https://www.instagram.com/maincode_software?igsh=Z3U4dmFkMWsxcG9l"><img src="insta_icon.svg" alt="" /></a>
                        </div>
                        <div>
                            <a target='_blank' href="https://www.linkedin.com/company/maincode-software/?viewAsMember=true"><img src="in_icon.svg" alt="" /></a>
                        </div>
                        <div>
                            <a target='_blank' href="https://wa.me/message/XPHLZEJHU6BMG1"><img src="whatsapp (1).png" alt="" className='w-9' /></a>
                        </div>
                    </div>
                </div>
                <div className='flex lg:w-[50%] w-[100%] md:w-[100%] md:justify-center lg:justify-center lg:mb-10 lg:mt-16'>
                    <div className="hidden lg:block lg:w-[100%] lg:relative lg:h-full">
                        <img
                            src="icone grande declarei.svg"
                            alt="pc"
                            className="absolute right-[40px] h-auto lg:h-[100%]"
                        />
                    </div>
                </div>
            </div>
            <div className='bg-white w-[100%]'>
                <FAQ />
            </div>
            <div className='flex w-[100%] h-[100%]'>
                <Footer />
            </div>
        </div>
    );
};

export default Contact;